import React from 'react';
import "./css/Home.css";
import BannerSection from './BannerSection';
import TopTrendingSection from './TopTrendingSection';
import AddSection from './AddSection';
import PopularIndianSection from './PopularIndianSection';
import PopularTourSection from './PopularTourSection';
import InternationalPackages from './InternationalPackages';
import PopularInternationalSection from './PopularInternationalSection';
import HolidayThemesSection from './HolidayThemesSection';
import SupportSection from './SupportSection';
import EnquiryPopup from '../Common/EnquiryPopup';
import Testimonial from '../Testimonial/Testimonial';
import MiceTravel from '../MiceTravel/MiceTravel';



const Home = () => {
    return (
        <>
            <div style={{ overflowX: "hidden" }}>
                <BannerSection />
                <MiceTravel />
                {/* <TopTrendingSection /> */}
                <InternationalPackages heading="Most Popular International Tours" />
                <PopularTourSection heading="Most Popular Indian Tours" />
                {/* <AddSection /> */}
                {/* <PopularIndianSection sheading="DESTINATION" fheading="Popular" secheading="Indian Destination"  /> */}
                <HolidayThemesSection />
                <Testimonial />
                {/* <PopularInternationalSection /> */}
                {/* <SupportSection /> */}
                {/* <EnquiryPopup /> */}
            </div>
        </>
    )
}

export default Home